import React, { PureComponent } from 'react';
import { Button, ButtonToolbar } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { render_field } from '../../../../utils/renderField';

const industry = [
    { value: 'Technology', label: 'Technology' },
    { value: 'Medicine', label: 'Medicine' },
    { value: 'Accounting', label: 'Accounting' },
    { value: 'Agriculture', label: 'Agriculture' },
    { value: 'Air Transport', label: 'Air Transport' },
    { value: 'Banking', label: 'Banking' },
    { value: 'Construction', label: 'Construction' },
    { value: 'Defense', label: 'Defense' },
    { value: 'Education', label: 'Education' },
    { value: 'Manufacturing', label: 'Manufacturing' },
    { value: 'Food', label: 'Food' }
]

class ProfileSettings extends PureComponent {

    constructor(props, context) {
        super(props, context);
        this.state = {
            name: 'Lora Kolly',
            email: 'lkolly@yourcompany.com',
            textarea: 'Hello world!',
            countries: [],
            regions: [],
            cities: [],
            currentCountry: {},
            currentRegion: {},
            currentCity: {},
            street: '',
            industry: null,

        };

        this.key = 'f1469bac628eeb013b607723b5d78c55'
        this.apiUser = 'shawkhail'

        this.initCountries = this.initCountries.bind(this)
        this.onButtutaCountryChange = this.onButtutaCountryChange.bind(this)
        this.onButtutaRegionChange = this.onButtutaRegionChange.bind(this)
        this.onButtutaCityChange = this.onButtutaCityChange.bind(this)
    }

    async componentDidMount () {
        //this.initCountries()
    }

    async componentDidUpdate (prevProps, prevState) {
        if (prevState.currentCountry !== this.state.currentCountry) {

            this.onButtutaCountryChange(this.state.currentCountry.geonameId)
        }

        if (prevState.currentRegion !== this.state.currentRegion) {
            this.onButtutaRegionChange(this.state.currentRegion.geonameId)
        }

    }

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };

    industryChange = industry => event => {
        this.setState({
            [industry]: event.target.value,
        });
    };

    async initCountries () {
        let Countries = null;
        const url = `http://api.geonames.org/countryInfoJSON?username=${this.apiUser}`
        await window.$.getJSON(url, function (countries) {
            Countries = countries.geonames
        })

        this.setState({
            countries: Countries,
            currentCountry: Countries[0]
        })
    }

    async onButtutaCountryChange (event) {
        let eValue;
        if (event === 'undefined' || event === undefined) {
            return;
        } else if (event.target === 'undefined' || event.target === undefined) {
            eValue = event
        } else {
            window.$.each(this.state.countries, function (key, country) {
                return country.countryName === event.target.value ? eValue = country.geonameId : null
            })
        }
        const url = `http://api.geonames.org/childrenJSON?geonameId=${eValue}&username=${this.apiUser}&hierarchy=geography` //eslint-disable-line max-len

        let Regions, cRegion, cCountry;
        await window.$.getJSON(url, function (regions) {
            regions.geonames ? Regions = regions.geonames : Regions = []
            Regions.length ? cRegion = Regions[0] : cRegion = {}
        })

        window.$.each(this.state.countries, function (key, country) {
            return country.geonameId === eValue ? cCountry = country : null
        })
        this.setState({
            regions: Regions,
            currentRegion: cRegion,
            currentCountry: cCountry
        })
    }

    async onButtutaRegionChange (event) {
        let eValue;
        if (event === 'undefined' || event === undefined) {
            this.setState({
                cities: [],
                currentCity: {}
            })
            return;
        } else if (event.target === 'undefined' || event.target === undefined) {
            eValue = event
        } else {
            window.$.each(this.state.regions, function (key, region) {
                return region.name === event.target.value ? eValue = region.geonameId : null
            })
        }
        const url = `http://api.geonames.org/childrenJSON?geonameId=${eValue}&username=${this.apiUser}&hierarchy=geography` //eslint-disable-line max-len
        let Cities, cCity, cRegion;
        await window.$.getJSON(url, function (cities) {
            cities.geonames ? Cities = cities.geonames : Cities = {}
            Cities.length > 1 ? cCity = Cities[0] : cCity = {}
        })

        window.$.each(this.state.regions, function (key, region) {
            return region.geonameId === eValue ? cRegion = region : null
        })
        this.setState({
            cities: Cities,
            currentCity: cCity,
            currentRegion: cRegion,
        })
    }

    onButtutaCityChange (event) {
        let cCity;
        window.$.each(this.state.cities, function (key, city) {
            return city.name === event.target.value ? cCity = city : null
        })

        this.setState({
            currentCity: cCity
        })
    }

    onStreetChange = street => event => {
        this.setState({
            [street]: event.target.value
        })
    }

    render () {
        const { handleSubmit } = this.props;
        //console.log(this.props.user)
        return (
            <form className='company-profile-form' onSubmit={handleSubmit}>
                <span id='company-profile-heading'> Configure your company information.</span>
                <br />
                <br />
                <div>
                    {/* <label className='material-form__label'>Company Name</label> */}
                    <Field
                        id='companyname'
                        name='companyname'
                        component={render_field}
                        type='text'
                        placeholder={this.props.user["custom:companyName"]}
                        onChange={this.handleChange('compnayname')}
                    />
                </div>
                <div>
                    {/* <label className='material-form__label'>Industry</label> */}
                    <Field
                        name='industry'
                        id='industry'
                        component={render_field}
                        type='select'
                        placeholder={this.props.user["custom:companyIndustry"]}
                        options={industry}
                        defaultValue={this.props.user["custom:companyIndustry"]}
                        onChange={(newIndustry => this.setState({ industry: newIndustry.value }))}
                        clearable={false}
                    />
                </div>
                <div>
                    {/* <label className='material-form__label'>Country</label> */}
                    <Field
                        name="country"
                        id='country'
                        //component={renderCountrySelect}
                        component={render_field}
                        type='select'
                        options={[
                            { label: "Select Country", value: "country" },
                            { label: "Jamaica", value: "Jamaica" },
                            { label: "United States", value: "us" }
                        ]}
                        onChange={this.onButtutaCountryChange}
                        defaultValue={'Jamaica'}
                    />
                </div>
                {/* <div>
                        <label className='material-form__label'>Region</label>
                        <Field
                            name="region"
                            component={renderRegionSelect}
                            onChange={this.onButtutaRegionChange}
                            label={this.state.regions ? this.state.regions : null}
                            //defaultValue = {this.state.countries ? this.state.countries : null}
                            defaultValue={this.state.currentRegion ? this.state.currentRegion.name : 'No Region'}
                        />
                    </div>
                    <div>
                        <label className='material-form__label'>City</label>
                        <Field
                            name="city"
                            component={renderCitySelect}
                            onChange={this.onButtutaCityChange}
                            label={this.state.cities ? this.state.cities : null}
                            //defaultValue = {this.state.countries ? this.state.countries : null}
                            defaultValue={this.state.currentCity ? this.state.currentCity.name : 'No City'}
                        />
                    </div>
                <div>
                    <label className='material-form__label'>Street</label>
                    <Field
                        name='street'
                        component={renderTextField}
                        placeholder='Street'
                        defaultValue={this.state.street}
                        onChange={this.onStreetChange('street')}
                    />
                </div> */}
                <ButtonToolbar className='form__button-toolbar'>
                    <Button color='primary' type='submit'>Save Changes</Button>
                    {/* <Button type='button' onClick={reset}>
                        Cancel
          </Button> */}
                </ButtonToolbar>
            </form>
        )
    }
}

export default reduxForm({
    form: 'profile_settings_form', // a unique identifier for this form
})(ProfileSettings);




// WEBPACK FOOTER //
// ./src/components/account/profile/components/CompanyProfile.js